import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import NumberFormat from 'react-number-format';

import RenderIf from '../../render-if/components/render-if';

import '../styles/custom-table.css';

class CustomTable extends Component {
  state = {
    active: '',
  };

  componentDidMount() {
    const { table } = this.props;

    if (table && table.length > 0) {
      this.setState({
        active: table[0].id,
      });
    }
  }

  setActiveHeader(id) {
    this.setState({
      active: id,
    });
  }

  getItemWidth(table) {
    return {
      width: `${100 / table.length}%`,
    };
  }

  renderHeader(table) {
    const { t } = this.context;
    const { active } = this.state;

    return table.map((item, index) => {
      return (
        <div key={index} className={`custom-table-wrapper__header__item ${active === item.id ? 'active' : ''}`} style={this.getItemWidth(table)} onClick={() => this.setActiveHeader(item.id)}>
          {t(item.header)}
        </div>
      );
    });
  }

  getValue(column) {
    return column.round ? parseFloat(column.value).toFixed(column.round) : column.value;
  }

  renderBody(table) {
    const { active } = this.state;
    const { t } = this.context;

    const tableItem = _.find(table, { id: active });

    if (tableItem && tableItem.columns) {
      return tableItem.columns.map((column, index) => {
        return (
          <div className="custom-table-wrapper__body__item" key={index}>
            <div className="title">{t(column.title)}</div>
            <RenderIf if={column.round}>
              <div className="value">
                <NumberFormat thousandSeparator={true} prefix={column.prefix || ''} value={this.getValue(column)} displayType={'text'} />
              </div>
            </RenderIf>
            <RenderIf if={!column.round}>
              <div className="value">{column.prefix || ''}{this.getValue(column)}</div>
            </RenderIf>
          </div>
        );
      });
    } else return null;
  }

  render() {
    const { table } = this.props;

    return (
      <div className="custom-table-wrapper">
        <div className="custom-table-wrapper__header">{this.renderHeader(table)}</div>
        <div className="custom-table-wrapper__body">{this.renderBody(table)}</div>
      </div>
    );
  }
}

CustomTable.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default CustomTable;



// WEBPACK FOOTER //
// ./src/app/shared/custom-table/components/custom-table.js